module.exports = __webpack_public_path__ + "img/nexultra-B-100.cff51f71.jpg";